import axios from "axios";

import fetchSeo from "common/fetch/fetchSeo";
import getEntityCountries from "common/fetch/getEntityCountries";

import Layout from "components/common/Layout";
import GrantsAndIncentives from "components/templates/sg/guide-and-tool/singapore-grants-incentives";
export default function Home({ data }) {
  return (
    <Layout locationRouter="sg" navLight={true} page={data?.page}>
      <GrantsAndIncentives data={data} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const locale = "sg";
  const uri = "/guide-and-tool/singapore-grants-and-incentives";
  const page = await fetchSeo({
    uri,
    locale,
  });
  // Const page = {};

  const resEntity = await getEntityCountries();

  const res_data_step = await axios.get(
    `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/tools/grant_scheme/grant_type`
  );
  const renameKeyOfObject = (obj) => {
    return {
      label: obj.name,
      value: obj.id,
      parent_id: obj.parent_id,
      is_disabled: obj.is_disabled,
    };
  };
  const step1 = {
    needs_based: res_data_step.data.data?.needs_based.attributes.map((item) =>
      renameKeyOfObject(item)
    ),
    industry: res_data_step.data.data?.industry.attributes.map((item) =>
      renameKeyOfObject(item)
    ),
    business_stage: res_data_step.data.data?.business_stage.attributes.map(
      (item) => renameKeyOfObject(item)
    ),
  };
  const step2 = {
    years_operation: res_data_step.data.data?.years_operation.attributes.map(
      (item) => renameKeyOfObject(item)
    ),
    business_size: res_data_step.data.data?.business_size.attributes.map(
      (item) => renameKeyOfObject(item)
    ),
    local_shareholding:
      res_data_step.data.data?.local_shareholding.attributes.map((item) =>
        renameKeyOfObject(item)
      ),
    number_employees: res_data_step.data.data?.number_employees.attributes.map(
      (item) => renameKeyOfObject(item)
    ),

    country_id: res_data_step.data.data?.country_id,
  };
  const step3 = {
    type: res_data_step.data.data?.type.attributes.map((item) =>
      renameKeyOfObject(item)
    ),
    agency: res_data_step.data.data?.agency.attributes.map((item) =>
      renameKeyOfObject(item)
    ),
  };

  return {
    props: {
      data: {
        page: page || {},
        entityData: resEntity.data.filter((item) => item.id !== 111) || [],
        step1,
        step2,
        step3,
      },
      revalidate: 1,
    },
  };
};
